var assetsHost = 'https://aui-cdn.atlassian.com/media';
export var getAssetUrl = function (assetName) { return assetsHost + "/" + assetName; };
//# sourceMappingURL=getAssetUrl.js.map